module.exports = __webpack_public_path__ + "img/17.b4a0821c.svg";